import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
// import { ItemClassDisplayOrderModel } from './model/system-settings.model';
import { HotItemDisplayOrderService } from './hot-item-display-order.service';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { get } from 'jquery';

@Component({
  selector: 'app-item-class-display-order',
  templateUrl: './hot-item-display-order.component.html',
  styleUrl: './hot-item-display-order.component.scss',
  standalone: false
})
export class HotItemDisplayOrderComponent implements OnInit, DirtyCheck {

  menuList: any[] = []; // Fill this with your API data
  filteredMenuDepartments: any[] = [];
  itemSubClasses: any;
  itemRows: any[] = [];
  dropLists: string[] = []; // hold connected drop list ids
  menuDepartmentControl: FormControl<string | null>;
  itemClassForm!: FormGroup;
  isFormDirty: boolean = false;
  lastConfirmedMenuId: number | null = null;
  menuId: any;
  numberOfColumns: number = 5 + 1; // Default number of columns, can be changed based on requirements
  menuInitialized: boolean = false;
  menuColor: { name: string; value: string; } | undefined;
  sys_repl_ts: string | null = null;
  groupedItemRows: [string, any[]][] = [];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private builder: FormBuilder,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private hotItemDisplayOrderService: HotItemDisplayOrderService,
 
  ) {
    this.itemClassForm = this.builder.group({
      hot_item: this.builder.control('', [Validators.required, this.hotItemValidator]),
      number_of_columns: this.builder.control('')
    });

    this.menuDepartmentControl = this.itemClassForm.get('hot_item') as FormControl;
    // Removed overly aggressive isFormDirty setting on valueChanges. 
    // Dirty check is now solely handled by drop().

  }
  isDirty(): boolean {
    return this.isFormDirty;
  
  }

  ngOnInit() {
    this.getHotItemList();

    this.menuDepartmentControl.valueChanges
      .pipe(
        startWith(''),
        map(value => {
          //  this.isFormDirty = true;
          return this._filterMenuDepartments(value);
        })
      )
      .subscribe(filtered => this.filteredMenuDepartments = filtered);

    this.menuDepartmentControl.valueChanges.subscribe((selectedMenu: any) => {
      const selectedMenuId = typeof selectedMenu === 'object' ? selectedMenu?.id : null;
      if (!selectedMenuId) return;

      if (!this.menuInitialized) {
        // First time selection — just load, don't prompt
        this.loadNewMenu(selectedMenuId);
        this.menuInitialized = true;
        return;
      }

      if (this.isFormDirty && selectedMenuId !== this.menuId) {
        // Prompt before switching
        const message = `You have unsaved changes. Do you want to save before switching?`;
        const dialogData = new ConfirmDialogModel("Confirm Navigation", message);

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: dialogData
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // Save first
            this.saveAndSwitch(selectedMenuId);
          } else {
            // Discard and switch
            this.loadNewMenu(selectedMenuId);
          }
        });
      } else {
        this.loadNewMenu(selectedMenuId);
      }
    });
  }
    /**
   * Dirtyness check
   * @returns 
   */


  loadNewMenu(menuId: number) {
    this.menuId = menuId;
    this.lastConfirmedMenuId = menuId;
    this.isFormDirty = false;
    this.hotItemDisplayOrderList(menuId);
  }

  saveAndSwitch(menuId: number) {
    this.save();
    // Delay the load slightly after save to ensure it's processed
    setTimeout(() => {
      this.loadNewMenu(menuId);
    }, 10);
  }

async navBack(): Promise<void> {
  if (this.isFormDirty) {
    const message = "Are you sure you want to discard your changes? Your changes will be lost.";
    const dialogData = new ConfirmDialogModel("Discard unsaved changes?", message);
    const result = await this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    }).afterClosed().toPromise();

    if (result) {
      this.completelyReset();
    }
    // If not confirmed, do nothing
  } else {
    this.completelyReset();
  }
}

completelyReset(): void {
  this.itemClassForm.reset();
  this.menuDepartmentControl.setValue('');
  this.filteredMenuDepartments = this.menuList.slice();
  this.menuId = null;
  this.itemSubClasses = [];
  this.dropLists = [];
  this.menuColor = undefined;
  this.isFormDirty = false;
  this.menuInitialized = false;
  this.groupedItemRows = [];
}

  getHotItemList() {
 
         this.menuList = [
  { id: '', name: 'Select' },
  { id: 'h1', name: 'hot item1' },
  { id: 'h2', name: 'hot item2' },
  { id: 'h3', name: 'hot item3' },
  { id: 'h4', name: 'drive through' }
];
  }

  private _filterMenuDepartments(value: string | any): any[] {
    if (typeof value === 'object' && value !== null) {
      return this.menuList;
    }
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.name?.toLowerCase() || '';
    return this.menuList.filter(dept => dept.name.toLowerCase().includes(filterValue));
  }

  displayMenuDepartmentName(dept: any): string {
    return dept && dept.name ? dept.name : '';
  }

  filterMenuDepartments() {
    // Optionally trigger filtering manually if needed
    this.filteredMenuDepartments = this._filterMenuDepartments(this.menuDepartmentControl.value);
  }

  clearMenuDepartment() {
    this.menuDepartmentControl.setValue('');
  }

  hotItemValidator = (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null; // Allow empty (optional), or change as needed
    // If value is an object (selected from autocomplete), it's valid
    if (typeof value === 'object' && value.id) return null;
    // If value is a string, check if it matches any sale item name
    const match = this.menuList.some(item => item.name.toLowerCase() === value.toLowerCase());
    return match ? null : { invalidHotItem: true };
  };

  save() {
    this.itemClassForm.markAllAsTouched();
    if (this.itemClassForm.invalid) {
      // Show errors or prevent save
      return;
    }
    this.menuDepartmentControl.markAsTouched();
    if (this.menuDepartmentControl.invalid) {
      return;
    }
    const newData = this.itemSubClasses;
    let requestData = {
      hotItemDisplayOrder: newData,
      hotItemType: this.menuId, // Assuming menuDepartmentControl holds the selected menu object 
      sys_repl_ts: this.sys_repl_ts
    }

    this.hotItemDisplayOrderService.update(requestData).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          // handle success
          this.isFormDirty = false;
          let snckBarData: SnackBarData = {
            type: 'success',
            title: 'Saved',
            message: 'The hot item display order has been updated successfully.'
          }
          this.snackBarService.openSnackBar(snckBarData);
          if (this.menuId) {
            this.hotItemDisplayOrderList(this.menuId);
          }
        } else if (response.code === 'DATA_CHANGED_AT_SERVER') {
          let snackBarData: SnackBarData = {
            message: 'This record has been updated by another user. Please reload the data to see the latest changes.',
            title: 'Conflict Detected',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          if (this.menuId) {
            this.hotItemDisplayOrderList(this.menuId);
          }
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        // handle error
        let snackBarData: SnackBarData = {
          message: 'Failed to update. Connection to the server failed',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  hotItemDisplayOrderList(menuId: number) {
    this.hotItemDisplayOrderService.getHotItemDisplayOrderByMenuId(menuId).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          this.itemSubClasses = response.data.hotItemClasses;
          this.sys_repl_ts = response.data.sys_repl_ts;
        // this.loadGroupedItems(response.data.hotItemClasses);
          console.log('Item class display order loaded successfully:', this.itemSubClasses);
        } else {
          console.error('Failed to load item class display order:', response.message);
        }
      },
      error: (error: any) => {
        console.error('API error when loading item class display order:', error);
      }
    });
  }

  loadGroupedItems(data: any) {
    this.itemSubClasses = []; // Initialize the itemSubClasses arra
 for (const [category, items] of Object.entries(data)) {
  console.log(`Category: ${category}, Items:`, items);
      if (category !== 'unassigned' && Array.isArray(items)) {
        this.itemSubClasses.push(...items);
      }
    }
    
    // Add unassigned items at the end
    if (Array.isArray(data.unassigned)) {
      this.itemSubClasses.push(...data.unassigned);
    }
}

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.itemSubClasses, event.previousIndex, event.currentIndex);
    this.isFormDirty = true;
    // console.log(this.itemSubClasses);
  }

}